import { jsx as _jsx } from "react/jsx-runtime";
import MedicalMachines from 'pages/MedicalMachines';
import NewMedicalMachine from 'pages/NewMedicalMachine';
import ShowMedicalMachine from 'pages/ShowMedicalMachine';
import { Route } from 'react-router';
import AuthorizationService from '../AuthorizationService';
import { Index, Create, Show } from '../../constants/actions';
import { MedicalMachine as MedicalMachineResource } from '../../constants/resources';
var MedicalMachineRoutes = function () {
    return ([
        _jsx(Route, { caseSensitive: true, path: '/medical-machines/new', element: AuthorizationService.getAuthorizedElement(_jsx(NewMedicalMachine, {}), Create, MedicalMachineResource) }, 'new-machines-route'),
        _jsx(Route, { caseSensitive: true, path: '/medical-machines/:id', element: AuthorizationService.getAuthorizedElement(_jsx(ShowMedicalMachine, {}), Show, MedicalMachineResource) }, 'show-machine-route'),
        _jsx(Route, { caseSensitive: true, path: '/medical-machines', element: AuthorizationService.getAuthorizedElement(_jsx(MedicalMachines, {}), Index, MedicalMachineResource) }, 'medical-machines-route')
    ]);
};
export default MedicalMachineRoutes;
